import { render, staticRenderFns } from "./question-select.vue?vue&type=template&id=fca1127a&scoped=true"
import script from "./question-select.vue?vue&type=script&lang=js"
export * from "./question-select.vue?vue&type=script&lang=js"
import style0 from "./question-select.vue?vue&type=style&index=0&id=fca1127a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca1127a",
  null
  
)

export default component.exports